/* import __COLOCATED_TEMPLATE__ from './filters.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();